import { ref } from 'vue'

export default () => ({
  sessions: ref([])
})
